var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('h3',{staticClass:"title"},[_vm._t("title")],2),_c('p',{staticClass:"subtitle"},[_vm._t("subtitle")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }